import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { AtxModalSimpleComponent } from '../components';

@Injectable()
export class AtxModalService {
    constructor(private ngbModalService: NgbModal) {}

    public openSimpleModal (
        component: any,
        config: any = {},
        options: any = {}
    ): void {
        const modal = this.ngbModalService.open(AtxModalSimpleComponent, options);

        modal.componentInstance.content = component;
        modal.componentInstance.title = config.title;
        modal.componentInstance.hasFooter = config.hasFooter;
        modal.componentInstance.options = config.options || {};
        modal.componentInstance.fireSubmit = config.fireAccept;

        this.checkModalResult(modal, config.fireAccept, config.fireCancel);
    }

    private checkModalResult(modal: any, fireAccept?: Function, fireCancel?: Function) {
        modal.result.then(this.callFire(fireAccept), this.callFire(fireCancel));
    }

    private callFire(callback) {
        return () => {
            callback && callback();
        };
    }
}
